<template>
<!-- 司机-司机任务 -->
<!-- 发放时间:任务完成后奖励将在奖励发放周期结束后早5点发放 -->
    <div class="container">
        <div class="handle-box-search">
             <div class="handle-box">
                 <el-row class="head-search">
                    <el-col :span="8">
                        <span class="title">任务名称:</span>
                        <!-- 搜索任务名称 -->
                        <el-input
                            v-model="search_data.task_name"
                            placeholder="请输入任务名称"
                            class="handle-input mr10"
                            @keyup.enter.native="searchTaskLists"
                        ></el-input>
                    </el-col>
               
                </el-row>
                 </div>
            <el-button type="primary" @click="addBtn">添加任务</el-button>
            
            <el-button type="primary" icon="el-icon-search" @click="searchTaskLists">搜索</el-button>
             <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            <el-tooltip class="item" effect="dark" content="任务开启将会展示在司机端首页的任务-任务列表中，任务开启即生效，满足任务要求司机即可获得任务奖励" placement="right">
                            <i class="el-icon-question"></i>
                        </el-tooltip>
        </div>
        <!-- <el-table :data="tableData" class="table" ref="multipleTable" header-cell-class-name="table-header" row-key="id"
            :tree-props="{ children: 'condition_loop' }"> -->
            <!-- 听测试的建议，去掉父子关系展示，列表其他字段按雪丽发的截图展示 -->
            <el-table :data="tableData" class="table" ref="multipleTable" header-cell-class-name="table-header"
            >
            <el-table-column label="任务名称" prop="task_name" min-width="100px"> </el-table-column>
            <!-- <el-table-column label="在线时长" prop="condition_time"> </el-table-column> -->
            <!-- <el-table-column label="完成单数" prop="condition_order"> </el-table-column> -->
            <el-table-column label="奖励发放周期" prop="reward_cyclical"> </el-table-column>
            <el-table-column label="现金" prop="reward_amount"> </el-table-column>
            <el-table-column label="表现分" prop="reward_monitor"> </el-table-column>
            <el-table-column label="优享券" prop="reward_priority"> </el-table-column>
            <el-table-column label="优享券数量" prop="reward_priority_num"> </el-table-column>
          
            <!-- <el-table-column label="时间段" prop="time_range"> </el-table-column> -->
      
            <el-table-column label="活动生效日期" prop="start_date"></el-table-column>
            <el-table-column label="活动结束日期" prop="end_date"></el-table-column>
            <el-table-column label="状态" min-width="70px">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status == '1' ? 'success' : 'danger'">
                        {{ scope.row.status == '1' ? '开启' : '关闭' }}</el-tag
                    >
                </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                    <el-dropdown
                        split-button
                        type="primary"
                        @click="edit_isShow = !edit_isShow;driverChildren = scope.row;"
                        trigger="click"
                    >
                        统计

                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="detailTo(scope.row)"
                                >查看
                            </el-dropdown-item>

                            <el-dropdown-item @click.native="updateTaskStatus(scope.row.driver_task_code)">关闭 </el-dropdown-item>

                            <el-dropdown-item @click.native="toBlackList(scope.row)"
                                >黑名单
                            </el-dropdown-item>

                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>

          
        </el-table>
        <!-- element ui 原生分页组件 -->
        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="search_data.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="search_data.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="result_data.count"
            >
            </el-pagination>
        </div>

        <!-- 添加组件 把查看合并到添加页面了-->
        <addTaskDrawer :isShow="add_isShow" :btnType='btnType' :data="detailData" @onSubmit="taskLists"></addTaskDrawer>

        <!-- 统计 -->
        <editTaskDrawer :isShow="edit_isShow" :data="driverChildren" @onSubmit="taskLists"></editTaskDrawer>
 
        <!-- 黑名单组件 -->
        <blackList :isShow="black_isShow" :data="detailData" @onSubmit="taskLists"></blackList>
    </div>
</template>

<script>
var _this;
import blackList from './blackList.vue';
import addTaskDrawer from './addTaskDrawer.vue';
import editTaskDrawer from './editTaskDrawer.vue';

export default {
    components: {
        blackList,
        addTaskDrawer,
        editTaskDrawer,

        // recordTaskDrawer
    },
    data() {
        return {
            btnType: '', // 区分添加和编辑按钮
            detailData: {},
            black_isShow: false,
            driverChildren: '',

            add_isShow: false,

            edit_isShow: false,
            detail_isShow: false,

            // 存放表格数据
            tableData: [],

            //获取用户列表的数据
            search_data: {
                page: 1,
                limit: 10,
                task_name:''
            },

            result_data: {},
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.taskLists();
    },

    methods: {
        // 添加方法
        addBtn() {
          
            _this.btnType = 'add';

            // _this.addModel_isShow = !_this.addModel_isShow;
            _this.add_isShow = !_this.add_isShow;
    


        },
         // 黑名单
        toBlackList(val) {
            _this.black_isShow = !_this.black_isShow;
            _this.detailData = val;

      
        },
        // 查看
        detailTo(val){
            _this.btnType = 'edit';
            _this.add_isShow = !_this.add_isShow;
            _this.detailData = val;
       

        },
        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
          
            _this.search_data.limit = val;

            //初始化列表
            _this.pages_function();
        },
        //页码变化
        handleCurrentChange(val) {
            _this.search_data.page = val;
            //初始化列表
            _this.pages_function();
        },
        //翻页组件的回调
        pages_function() {
            //初始化列表
            _this.taskLists();
        },
        // 关闭
        updateTaskStatus(driver_task_code) {
            _this
                .$post('/task_new/updateTaskStatus', {
                    driver_task_code: driver_task_code
                })
                .then((res) => {
                    this.$message.success(res.msg);
                    _this.taskLists();
                })
                .catch((err) => {});
        },

        searchTaskLists() {
            _this.search_data.page = 1;
            _this.taskLists();
        },

        taskLists() {
            _this
                .$post('/task_new/driverTaskLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;
                })
                .catch((err) => {});
                
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>